/*

Created:	Ziv Emmet
Date:		Mon Nov 13th, 2017	

*/

var ext_=null;

var mycartevents = null;

var giftset = null;

var localgifterenabler = null;


$(document).ready(function(){


  var loadfonts = function(){
  


  }
  
  var coinswitcher = function(){
  
  	$('#coin-container').append($('#shopifycurrencyswitcher'));
    
    $('#shopifycurrencyswitcher select').bind('change',function(){
      $(this).parent()[0].submit()
    })
  }
  
  var watchesmenutoggle = function(){
  
    return;
    
    //$('.desktop-main-menu a[data-for="menu1toggle"]').attr('href','javascript:void(0)');
    $('.desktop-main-menu a[data-for="menu1toggle"]').click(function(){
    
      if ($(this).parent().hasClass('hover-menu')){
      	
        $(this).parent().removeClass('hover-menu');
        
      }
      else{
      
      	$(this).parent().addClass('hover-menu');
      }
    	
    });
    $('.desktop-main-menu a[data-for="menu2toggle"]').attr('href','javascript:void(0)');
    $('.desktop-main-menu a[data-for="menu2toggle"]').click(function(){
    
      if ($(this).parent().hasClass('hover-menu')){
      	
        $(this).parent().removeClass('hover-menu');
        
      }
      else{
      
      	$(this).parent().addClass('hover-menu');
      }
    	
    });
  
  }
  
  var eventpixel_addtocart = function(){
  	
       // -- Taboola Pixel
    
    	/*
       _tfa.push({notify: 'event', name: 'add_to_cart', id: 1123632});
       $("<img src='//trc.taboola.com/1123632/log/3/unip?en=add_to_cart' width='0' height='0' style='display:none'/>").appendTo("body");
       $("<noscript><img src='//trc.taboola.com/1123632/log/3/unip?en=add_to_cart' width='0' height='0' style='display:none'/></noscript>").appendTo("body");
    	*/
  }
  
  var eventpixel_productpage = function(){
  	
    window.setTimeout(function(){
    
      // -- Taboola Pixel
      /*
      _tfa.push({notify: 'event', name: 'view_content', id: 1123632});
      $("<noscript><img src='//trc.taboola.com/1123632/log/3/unip?en=view_content' width='0' height='0' style='display:none'/></noscript>").appendTo("body");
	  */
    
    },100);
    
  }
  
  var checkNotifyExist = null;
  
  var collectionslider = (function(){
  
    var slideoff = function(){
      
      //console.log(switch_speed);
    
      $('.collection_slide2').css('opacity', '0');
        
      window.setTimeout(function(){
      	
        slideon();
      
      },switch_speed);	
    	
    }
    
    var slideon = function(){
    
      //console.log(switch_speed);
      
      $('.collection_slide2').css('opacity', '1');
        
      window.setTimeout(function(){
      	
        slideoff();
      
      },switch_speed);	

        
    };	

    if ($('div').hasClass('collection-slider-enable')){
      
      console.log('collection-slider-enable');
      
      window.setTimeout(function(){slideon();},1000);
      
    }
    
  })();
  
  var openNotifyMebutton = function(){
    
    if ($('body').hasClass('template-product')){
      
      if ($('#AddToCartText-product').text() == 'Sold Out'){
      
          checkNotifyExist = setInterval(function() {
             if ($('.klaviyo-bis-trigger').length) {
                $('.klaviyo-bis-trigger')[0].click();
                clearInterval(checkNotifyExist);
             }
          }, 1000); // check every 1000ms
      }
    }
  }
  
  var addToCartEvents = function(){
  
    if ($('body').hasClass('template-product')){

      if ($('button#AddToCart-product').length > 0){
      
        $('button#AddToCart-product').click(function(){

			eventpixel_addtocart();
          
            try{

              hj('trigger', 'addtocart');
            }
          	catch(e){}
        });
	
      }
      
	  eventpixel_productpage();
      
    }
  }
  
  var customizeProductEvent = function(){
  		
    return;
    
    if ($('span#tag_cloud_').length > 0){
    
    	var p = $('span#tag_cloud_').attr('tags');
      
        if (p.indexOf('customize') > -1){
			
          
          	$('button#AddToCart-product').parent().parent().attr('action','');
 
          	var cls = $('button#AddToCart-product').attr('class');
            var p = $('button#AddToCart-product').parent();
            $('button#AddToCart-product').remove();
          
            $('<input id="customizer-location" type="button" class="' + cls + '" value="CUSTOMIZE">').appendTo(p);
          
          
            $('input#customizer-location').css('letter-spacing','3px');
            $('input#customizer-location').click(function(){
            
            	location.href="https://torgoen.com/pages/torgoen-t41-multifunction-pilot-watch";	
              
            });
          
        }
    }
    
  }
  
  var readmore = (function(){

    var less = function(){
      slideup();
    }

    var more = function(){

      slidedown();
    }

    var slidedown = function(){

      $(".readmore").slideDown(function(){

        $('.readmorelink').remove();
        $('<a href="javascript:void(0)" class="readlesslink">Less</a>').insertAfter('.readmore');
        $('.readlesslink').click(function(){
          less();
        });

      });
    }

    var slideup = function(){
      $(".readmore").slideUp(function(){

        $('.readlesslink').remove();
        $('<a href="javascript:void(0);" class="readmorelink">More</a>').insertBefore('.readmore'); 
        $('.readmorelink').click(function(){
          more();
        });
      });
    }

    return{
      less:less
    }

  })();

  var yotposcroll = function(){
  
    if ($('div').hasClass('y-slider-container')){
    
        var step = 80;
      
        if (ismobile()){
        	
          step = 40;
        
        }
      
        //console.log(step);
      
        $('.y-slider-container.y-slide-left-animations').css('left','-20%');
        $('.y-slider-container.y-slide-left-animations').css('width','634%');

        $('.yotpo-icon-left-arrow-thin').click(function(){

            var L = $('.y-slider-container').css('left');
            var i = parseInt(L.slice(0,-1));
            i=i+step;
            if (i < -730) {i=-20;}
            if (i > -10) {i=-730;}
            $('.y-slider-container').css('left', i + '%');

        });

        $('.yotpo-icon-right-arrow-thin').click(function(){

            var L = $('.y-slider-container').css('left');
            var i = parseInt(L.slice(0,-1));
            i=i-step;
            if (i < -730) {i=-20;}
            if (i > -10) {i=-730;}
            $('.y-slider-container').css('left', i + '%');

        });
      
      	$('.yotpo-lightbox-product > a').each(function(index,val){$(val).attr('target','_self')});
      
     }
  }
  
  var yotpomobilereview = function(){
  
    if ($('body').hasClass('template-product')){
    	
      $('.yotpo-main-widget').clone().appendTo('#shopify-product-reviews');
    
      if (ismobile()){
        // clicking on reviews link
        $('.text-m').click(function(){	
          	$('#tab-2').next().trigger('click');
        });
      }
      else{
        // clicking on reviews link
        $('.text-m').click(function(){$('.tab-link-2').trigger('click');});

      }
    }
  }
  
  var ismobile = function () {
     if(window.innerWidth <= 769) {
       return true;
     } else {
       return false;
     }
   }
  
  var checksidebar = function(){
  
    if (typeof(enablesidebar) != 'undefined'){
    	
      if (!enablesidebar){
      
        window.setTimeout(function(){
        
        	$('#collectionFilters').remove();
          	$('.collection-products').removeClass('large--three-quarters');
          	$('.collection-products > .grid-uniform').css('margin-left','0px');
        
        },0);
      	
      }
    }
  
  }
  
  var checkenablecatdescription = function(){
  
    if (typeof(enablecatdescription) != 'undefined'){
    	
      if (!enablecatdescription){
      
        window.setTimeout(function(){
        
        	$('.collection-grid .collection-description').parent().hide();
        
        },500);
      	
      }
    }
    
    if (typeof(enablecatdescription_mobile) != 'undefined'){
    	
      if (enablecatdescription_mobile){
      
		$('.grid__item.collection-products > div.has-border-bottom:first-child').show();

      }
    }
  }	  
  
  var enablecollectiondiscountbadge = function(){
  
    if (typeof(enablediscountbadge) != 'undefined'){
      if (enablediscountbadge){
        	
        	$('.collection-grid .grid-inner').each(function(indx,val){
              
              try{
              
              	if ($(val).find('.money').length > 0){
              
                if ($(val).find('.price_wrapper .price .money').length > 0){

                  var price;
                  
                  if ($('#shopifycurrencyswitcher select').val() == 'USD'){
                  
                  	price =   $(val).find('.price_wrapper .price .money .money').text().substr(1);
                  }
                  else{
                  
                  	price =   $(val).find('.price_wrapper .price .money').text().substr(1);
                  }
                  
                  if ($(val).find('.price_wrapper .compare-at').length > 0){

                      var compare;

                      if ($('#shopifycurrencyswitcher select').val() == 'USD'){

                        compare =   $(val).find('.price_wrapper .compare-at .money .money').text().substr(1);
                      }
                      else{

                        compare =   $(val).find('.price_wrapper .compare-at .money').text().substr(1);
                      }
                    
                      var percent = parseInt(price) / parseInt(compare);

                      var k = ((1-percent)*100).toFixed(0);
                    
                      if ((k % 5) <= 2){
							
                        	k = k - (k % 5);
                      }
                    
                      $(val).append($('<div class="discountpercentbadge ge-hide"><div>' + k + '% </div><div>OFF</div></div>'));
                  }

                  //console.log($(val).find('.price_wrapper em').text());

                  if ($(val).find('.discountpercentbadge div:first-child').text().trim() == '0%'){
                  
                  	  $(val).find('.discountpercentbadge').css('visibility','hidden');
                  }
                  
                  if ($(val).find('.price_wrapper em').text() == 'Sold Out'){

                      // $(val).find('.discountpercentbadge').css('visibility','hidden');

                      //console.log($(val).find('.discountpercentbadge')[0]);
                  }

                }
              }
                
              }
              catch(e){}
              
            });
        
        	$('.discountpercentbadge').show('slow');
      }
    }
  }

   var enablenewbadge = function() {
     if (typeof(enablenewprodbadge) != 'undefined'){
      if (enablenewprodbadge) {
        $('.collection-grid .new-badge .grid-inner').each(function(indx,val) {
          $(val).append($('<div class="new_badge"><div><div>NEW IN</div><div>OUTLET</div></div>'));
        })
      $('.new_badge').show('slow');
       }
     }
  }

  var enableextrabadge = function() {
    if (enableextrabadge) {
      $('.collection-grid .extra-15 .grid-inner').each(function(indx,val) {
        $(val).append($('<div class="extra_15"><div><div>EXTRA</div><div>15% OFF</div></div>'));
      })
    }
    $('.extra_15').show('slow');
  }

  var enablenewprod = function() {
    if (enablenewprod) {
      $('.wrapper-watchblocks .new-prod').each(function(indx,val) {
        $(val).append($('<div class="new_prod"><div><div>NEW</div><div'));
      });
    }
  }

  var enablenewprodincol = function() {
    if (typeof(enablenewprodbadge) != 'undefined'){
      if (enablenewprodbadge !="") {
        $('.collection-grid .new-prod .grid-inner').each(function(indx,val) {
          console.log("2VAL", val);
          $(val).append($('<div class="new_prod"><div><div>NEW</div><div'));
        })
      $('.new_prod').show('slow');
      }
    }
  }
  
    
  var hideproductdiscountvariant = function(){
  
	$('div[data-option="discount"]').hide();
  }
  
  var mobileaddtocart = function(){
  
    if (ismobile()){
  	 //$('#proonto-widget').hide;
     //$('.template-product .add-to-cart__wrapper').append($('<div class="mobileaddstrap">ADD A STRAP</div>'));
     //$('.template-product .add-to-cart__wrapper').append($('<hr/>'));
      $('body.template-product').append($("<a href='javascript:void(0)' class='mobileatcbutton'><span>ADD TO CART</span></a>"));
     //$('.template-product #AddToCart-product').hide();
     $('.template-product .inner-data > .share').hide();
	 $('.template-product p[data-block-id="1508757081797"]').hide();
     $('.template-product .product-page').css('padding-bottom','0px');
      
      
     $('.template-product .mobileatcbutton').click(function(){

		$('#AddToCart-product').trigger('click');
      
        $('.mobileatcbutton').css('background-color','#272727');
       
        window.setTimeout(function(){
       	
         	$('.mobileatcbutton').css('background-color','#000');
         	
        },2000);
       
     });
    }
  }
  
  var klarnarefresh = function(price){
    
    if ($('select[name="currency"]').val() == 'USD'){
      
        document.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", price);
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      
    }
  }
  
  var shoppadinit_ = function(){
  
    window.setTimeout(function(){
    
      try{
        if ($('#shopifycurrencyswitcher select').val() != 'USD'){

          //$('.klarna_').remove();

        }
      	}catch(e){};
      
    },1000);
		
  
  }
  
  var klarnainit = function(){
    
    $('#upgradetosapphire').click(function(){
    
      if ($('#upgradetosapphire')[0].checked){
      	klarnarefresh(meta.product.variants[1].price);
      }
      else{
      	klarnarefresh(meta.product.variants[0].price);
      }

    });
  
  }
  
  var bundler_cart = function(){
  
	//console.log('bundler_cart: ' + Shopify.cart.attributes['bundler_cart']);
    
    var cart_ = null
    
    if (!Shopify.cart){
    
        Shopify.getCart(function(cart_){

          Shopify.cart = cart_;
          
          cart_bundler_proc();

        });
    }
    else{
    
    	cart_bundler_proc();
    }

    
    function cart_bundler_proc(){

          	//console.log('cart_bundler_proc');
          
            if ($('body#your-shopping-cart').length > 0){
                if (Shopify.cart.item_count == 0){

                    $.ajax({
                    type: 'POST',
                    url:  '/cart/update.js',
                    data: {"attributes[bundler_cart]": 'false'}, 
                    success: function(d){},
                    dataType: 'json'
                    });
                }
                else{

                    if (Shopify.cart.attributes['bundler_cart'] != 'true'){

                        $.ajax({
                        type: "POST",
                        url: '/cart.js',
                        data: {"attributes[bundler_cart]": 'true'}, 
                        success: function(d){},
                        dataType: 'json'
                        });

                        Shopify.cart.attributes['bundler_cart'] = 'true';
                    }
                }
        	}
            else{
				Shopify.cart.attributes['bundler_cart'] = 'false';
            }

            if (Shopify.cart.attributes['bundler_cart'] == 'true'){

              $('.CartToggle').unbind();
              $('.CartToggle').parent().unbind();
              $('.CartToggle').parent().click(function(){
              
              	location.href="/cart";
                
              });

            }
    }
     
  }
  
  var addcollection_banner = function(){
  
    if ($('body.template-collection .collection_promotionbanner').length > 0){
    
    	$('.collection-grid .grid-uniform .product-grid-item').parent().append($('.collection_promotionbanner'));
      
      	$('.collection_promotionbanner').show();
    }
  
  }
  
  var hideMissingVariant = function(){
  
  	
    if ($('body').hasClass('template-product')){
    
    	//console.log($('#tag_cloud_').attr('tags'));
      
        if ($('.swatch[data-option="crystal"] .soldout').length < 2){
          
          	$('.swatch[data-option="crystal"] .soldout').hide();

        }
    
    }
  }
  
    var movesoldoutatthebottom = function(){
    if (typeof(soldoutatthebottom) != 'undefined'){
      if (soldoutatthebottom){
    
        $('.grid-uniform .grid__item .grid-inner').each(function(indx,val){

          if ($(val).hasClass('sold_out')){
          	console.log($(val).parent()[0]);
            var parentDiv = $(val).parent();
            $(parentDiv.parent().append(parentDiv));
          }
          
        });	
        
        
      }
    }    
  }
    
    var swell_submit = function () {
    if (typeof swellAPI == "object") {
      var email = $(
        'form.klaviyo-form-version-cid_1 input[type="email"]'
      ).val();

      swellAPI.captureNewsletterSignup(
        email,
        function () {
          console.log("signup success");
        },
        function () {
          console.log("signup error");
        }
      );
    }
  };
    
    
  var klaviyo_signup = function () {
    window.addEventListener("klaviyoForms", function (e) {
      if (e.detail.type == "submit") {
        //console.log('submit');

        swell_submit();
      }
    });
  };

  var hideGiftCard = function () {
    if (
      $(".infinit_scroll").length > 0 &&
      $(".pagination .next a").length > 0
    ) {
      $inf.on("append.infiniteScroll", function (event, response, path, items) {
        $(".gift-card").hide();
        $(".gift-card:first-child").show();
      });
    }
  };  
    
    
  
  giftset = (function(){
  
  
  })();
 
  
  
  coinswitcher();
  readmore.less(); 
  addToCartEvents();
  openNotifyMebutton();
  klaviyo_signup();
  checkenablecatdescription();
  checksidebar();
  hideproductdiscountvariant();
  //watchesmenutoggle();
  mobileaddtocart();
  klarnainit();
  shoppadinit_();
  bundler_cart();
  addcollection_banner();
  hideMissingVariant();
  movesoldoutatthebottom();

  
  window.setTimeout(function(){yotposcroll();yotpomobilereview();},2000);
  window.setTimeout(function(){enablecollectiondiscountbadge();},7000);
  window.setTimeout(function(){enablenewbadge();},7000);
  window.setTimeout(function(){enablenewprod();},7000);
  window.setTimeout(function(){enablenewprodincol();},7000);
  window.setTimeout(function(){enableextrabadge();},7000);


  // animate extend
  
  $.fn.extend({
    animateCss: function(animationName, callback) {
      var animationEnd = (function(el) {
        var animations = {
          animation: 'animationend',
          OAnimation: 'oAnimationEnd',
          MozAnimation: 'mozAnimationEnd',
          WebkitAnimation: 'webkitAnimationEnd',
        };

        for (var t in animations) {
          if (el.style[t] !== undefined) {
            return animations[t];
          }
        }
      })(document.createElement('div'));

      this.addClass('animated ' + animationName).one(animationEnd, function() {
        $(this).removeClass('animated ' + animationName);

        if (typeof callback === 'function') callback();
      });

      return this;
    },
  });
  
  // needs to remain global
  
  localgifterenabler = function(){
  	
    /*
    	
        Is called from gifter_builder.js init funciton.
        Incase there is a bundler_cart item the enabler response is false,
        in order to cancel shopify script popup
    
    */
    
    
    var bundler_cart = false;
    
    try{
    	bundler_cart = (Shopify.cart.attributes['bundler_cart'] === 'true');
    }
    catch(e){}
    
  	return !bundler_cart;
  }
  
  mycartevents = (function(){
     
   var onbuiltcart = function(cart){
    	
     	//return;
     
        window.setTimeout(function(){
           
          if (typeof(bundler_logic)!='undefined'){
            
            try{
            	bundler_logic.cartevents(cart);
            }
            catch(e){}
              

          }
          else{
          
          	//console.log("bundler_logic not initiated");
          }
          
          
          if (typeof(gifter_logic)!='undefined'){
            
            try{
            	gifter_logic.giftcartevents(cart);
            }
            catch(e){}
          }
          else{
          
          	//console.log("gifter_logic not initiated");
          }
          
          if (typeof(upsale913)!='undefined'){
            
              try{
                  upsale913.cartevent(cart);
              }
              catch(e){}
          }
          else{
          
          	//console.log("upsale913 not initiated");
          }
          
          }, 2000);
      
      
          try{

            hj('trigger', 'addtocart');
          }
          catch(e){}
      
    }
    
    return{
    
      onbuiltcart:onbuiltcart
    }
  
  })();
  
});
